import React from 'react';
import * as Sentry from '@sentry/react';

import { trackGA4Event } from '../../tracking';
import { GA4Event } from '../../tracking/event-types';

/** Used to wrap any component, to prevent errors from crashing
 * the entire component tree. 
 * Example usage:
 * ```tsx
  * <ErrorBoundary>
  *  <MyComponentThatMightCrash />
  * </ErrorBoundary>
 ```
 * 
 * Errors are logged to Sentry!
 */
export function ErrorBoundary({
  children,
  errorUI,
}: {
  children: React.ReactNode;
  errorUI?: React.ReactNode;
}) {
  return (
    <Sentry.ErrorBoundary onError={onError} fallback={<>{errorUI}</>}>
      {children}
    </Sentry.ErrorBoundary>
  );
}

function onError(
  error: unknown,
  componentStack: string,
  eventId: string
): void {
  console.error('[TOMIS ChatBot] Crashed for unknown reason');
  trackGA4Event(GA4Event.Crashed, { sentryEventId: eventId, componentStack });
}
